const PREFIX = 'COLLECT_SIZES_';
export const IF_USER_CREATED_BEFORE_REQUEST = `${PREFIX}IF_USER_CREATED_BEFORE_REQUEST`;
export const IF_USER_CREATED_BEFORE_SUCCESS = `${PREFIX}IF_USER_CREATED_BEFORE_SUCCESS`;
export const IF_USER_CREATED_BEFORE_FAILURE = `${PREFIX}IF_USER_CREATED_BEFORE_FAILURE`;
export const ifCollectSizesBeforeRequest = () => ({
  type: IF_USER_CREATED_BEFORE_SUCCESS,
  payload: {
    isUserCreatedCollectSizesBefore: false
  }
});